import React from "react";
import { Modal } from "../../../components/Modal";
import { Button } from "../../../components/Button";
import { Div, Text } from "../../../styles/Common";
import alert from "../../../assets/icons/alert.svg";
import { theme } from "../../../styles/theme";
export const ModalConfirm = ({
  openConfirmation,
  handleCloseConfirmation,
  confirmRevokeAccess,
  handleCancel,
  isLoading,
}) => {
  return (
    <Modal
      open={openConfirmation}
      onCancel={handleCloseConfirmation}
      align={"center"}
      padding={36}
    >
      <Modal.Header
        icon={alert}
        iconBackground={theme.colors.salmon}
        iconWidth={"24px"}
        iconHeight={"24px"}
        align={"-webkit-center"}
        padding="16px 0 16px 0"
        title={"Are you sure you want to remove the last user?"}
      />
      <Modal.Body margin="16px 0 24px 0" maxHeight={200} align="center">
        <Text
          size={theme.fonts.size.default}
          weight={theme.fonts.weight.medium}
          color={theme.colors.grey1}
          style={{ textAlign: "center" }}
        >
          Removing the last user will leave the project without any assigned users.
        </Text>
      </Modal.Body>
      <Modal.Footer style={{ flexDirection: "column" }}>
        <Div gap="32px" justify="center">
          <Button
            onClick={handleCancel}
            border={theme.colors.dark}
            color={theme.colors.dark}
          >
            No, cancel
          </Button>
          <Button
            onClick={confirmRevokeAccess}
            background={theme.colors.salmon}
            loading={isLoading}
          >
            Yes, remove
          </Button>
        </Div>
      </Modal.Footer>
    </Modal>
  );
};